import React, { Component, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import {
  actions as sitesActions,
  operations as sitesOperations,
} from '../../redux/sitesManager'
import SitesSearch from './component'

export const SitesSearchContainer = ({
  clearSites,
  fetchSites,
  isLoading,
  sites,
}) => {
  const [criteria, setCriteria] = useState({})

  const addProperty = (key, value, object) => {
    return { ...object, [key]: value }
  }

  const removeProperty = (key, object) => {
    const { [key]: _, ...updatedObject } = object
    return updatedObject
  }

  const updateCriteria = (key, value) => {
    const updatedCriteria = !value
      ? removeProperty(key, criteria)
      : addProperty(key, value, criteria)

    setCriteria(updatedCriteria)
  }

  const clearSearch = () => {
    setCriteria({})
    clearSites()
  }

  const search = () => {
    fetchSites(criteria)
  }

  return (
    <SitesSearch
      clearSearch={clearSearch}
      criteria={criteria}
      handleChange={event =>
        updateCriteria(event.target.name, event.target.value)
      }
      handleKeydown={e => {
        if (e.keyCode === 13) search()
      }}
      isLoading={isLoading}
      search={search}
      sites={sites}
      updateCriteria={updateCriteria}
    />
  )
}

SitesSearchContainer.propTypes = {
  clearSites: PropTypes.func.isRequired,
  fetchSites: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  sites: PropTypes.array,
}

const mapStateToProps = ({ router, sitesManager }) => {
  return {
    ...router,
    sites: sitesManager.sites.data,
    isLoading: sitesManager.sites.isLoading,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...sitesActions,
      ...sitesOperations,
      push,
    },
    dispatch,
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SitesSearchContainer)



// WEBPACK FOOTER //
// ./src/components/SitesSearch/container.js